import RestResponse from "@/models/client/RestResponse";
import { CrudServiceType, crudService } from "./crudService";
import { RestClient } from "./restClient";
import Tenant, { ParentTenantInformation } from "@/models/tenant/tenant";
import RequestMethod from "@/models/client/RequestMethod";
import { TenantDocumentMetadata } from "@/models/metadata/metadata";

export type TenantServiceType = CrudServiceType<Tenant> & {
  getCurrent: () => RestResponse<Tenant>;
  getPageContent: () => RestResponse<string>;
  getParentTenantInformation: () => RestResponse<ParentTenantInformation>;
  getAvailableSubtenants: () => RestResponse<Tenant[]>;
  addAdminEmail: (email: string, tenantId: string) => RestResponse<string>;
  removeAdminEmail: (email: string, tenantId: string) => RestResponse<string>;
  putToneOfVoice: (
    tenantId: string,
    toneOfVoice: string
  ) => RestResponse<string>;
  updateMetadata: (
    tenantId: string,
    tenantMetadataList: TenantDocumentMetadata[]
  ) => RestResponse<Tenant>;
  deleteTenantMetadata: (tenantMetadataId: string) => RestResponse<Tenant>;
};

const tenantServices = (
  client: RestClient,
  path: string
): TenantServiceType => ({
  ...crudService<Tenant>(client, path),
  getCurrent: async () => {
    const response = await client.fetch<Tenant>(
      RequestMethod.GET,
      `${path}/current`
    );
    return response;
  },
  getPageContent: async () =>
    await client.fetch<string>(RequestMethod.GET, `${path}/pageContent`),
  getParentTenantInformation: async () =>
    await client.fetch<ParentTenantInformation>(
      RequestMethod.GET,
      `${path}/parent-tenant`
    ),
  getAvailableSubtenants: async () =>
    await client.fetch<Tenant[]>(
      RequestMethod.GET,
      `${path}/available-subtenants`
    ),
  addAdminEmail: async (email: string, tenantId: string) =>
    await client.fetch<string>(
      RequestMethod.PUT,
      `${path}/admin/add/${tenantId}`,
      {
        email,
      }
    ),
  removeAdminEmail: async (email: string, tenantId: string) =>
    await client.fetch<string>(
      RequestMethod.PUT,
      `${path}/admin/remove/${tenantId}`,
      {
        email,
      }
    ),
  putToneOfVoice: async (tenantId: string, toneOfVoice: string) =>
    await client.fetch<string>(
      RequestMethod.PUT,
      `${path}/${tenantId}/tone-of-voice`,
      {
        toneOfVoice,
      }
    ),
  updateMetadata: async (
    tenantId: string,
    tenantMetadataList: TenantDocumentMetadata[]
  ) =>
    await client.fetch<Tenant>(
      RequestMethod.PUT,
      `${path}/${tenantId}/metadata`,
      { tenantDocumentMetadata: tenantMetadataList }
    ),
  deleteTenantMetadata: async (tenantMetadataId: string) =>
    await client.fetch<Tenant>(
      RequestMethod.DELETE,
      `${path}/metadata/${tenantMetadataId}`
    ),
});

export default tenantServices;
